export function initBackLink() {

    window.backLink = function () {
        if (document.referrer === "") {
            window.location = "/";
        } else {
            history.back();
        }
    };

}